<template>
  <el-container style="height: 100%">
    <el-header class="header">

      <div>
        <div class="user">
          <div>
            欢迎您！ <i class="el-icon-user-solid i_icon ">{{ userInfo.username}}</i>
            <i  class=" el-icon-setting i_icon icon_hover " @click="checkDialog">修改密码</i>
            <i class="el-icon-switch-button i_icon icon_hover" @click="openConfirm">退出</i>
          </div>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside class="aside">
        <el-col @click="getTime">
          <el-menu style="width: 100%"
                   class="el-menu-vertical-demo"
                   unique-opened
                   router
          >
            <div v-for="(item,i) in navList" :key="i">
              <div v-if="item.child.length == 0">
                <el-menu-item    :index="item.route"  @click="getTime">
                  <i :class="item.icon"></i>
                  <span slot="title">{{ item.name}}</span>
                </el-menu-item>
              </div>
              <div v-else >
                <el-submenu :index="item.id + ''">
                  <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{ item.name}}</span>
                  </template>
                  <el-menu-item-group v-for="(sub_item,sub_i) in item.child" :key="sub_i">
                    <el-menu-item :index="sub_item.route" >
                      <i :class="sub_item.icon"></i>
                      <span slot="title">{{ sub_item.name}}</span>
                    </el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </div>
            </div>
            <!--            <el-menu-item  v-for="(item,i) in navList" :key="i" :index="item.menu_route"  @click="getTime">-->
            <!--                <i :class="item.menu_icon"></i>-->
            <!--              <span slot="title">{{ item.menu_heading}}</span>-->
            <!--            </el-menu-item>-->
          </el-menu>
        </el-col>
      </el-aside>
      <el-main style="padding: 2px 0 0 20px!important;">
        <el-card class="box-card main">
          <router-view :key="time"></router-view>
        </el-card>
      </el-main>
    </el-container>
<!--    <el-footer class="footer">-->
<!--      <div class="ip_info">-->
<!--        备案信息-->
<!--      </div>-->
<!--    </el-footer>-->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="500px" class="dialog-title">
      <el-form label-position="center" label-width="100px" :model="form"  :rules="passRules" ref="passForm" class="demo-ruleForm">
        <el-form-item label="原密码" prop="password" class="width-400">
          <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock" minlength="6" clearable placeholder="密码" v-model.trim="form.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password" class="width-400">
          <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock" minlength="6" clearable placeholder="新密码" v-model.trim="form.new_password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="new_password_confirmation" class="width-400">
          <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock" minlength="6" clearable placeholder="新密码" v-model.trim="form.new_password_confirmation" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changePass('passForm')">保 存</el-button>
        <el-button @click="callOf('passForm')">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {changeUserPass, getUserMenu} from '../api/auth'
export default {
  name: 'index',
  mounted () {
    this.setUserInfo()
    this.setMenuList()
  },
  data () {
    return {
      time: '',
      userInfo: {},
      navList: [],
      loading: false,
      form: {
        password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      dialogFormVisible: false,
      passRules: {
        password: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        new_password_confirmation: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    setUserInfo () {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    getTime () {
      this.time = Date.now()
    },
    logout () {
      this.$store.commit('clearToken')
      this.$store.commit('clearUserInfo')
      this.$router.push({ name: 'login' })
    },
    checkDialog () {
      this.dialogFormVisible = true
    },
    changePass (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const storeData = this.form
          changeUserPass(storeData).then(res => {
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.dialogFormVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
    },
    callOf (formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    openConfirm () {
      this.$confirm('确定退出吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
        this.$notify({
          message: '已退出登录',
          type: 'success',
          offset: 100,
          showClose: false
        })
      }).catch(() => {
      })
    },
    setMenuList () {
      getUserMenu().then(res => {
        let {status, message, data} = res
        if (status === 2000) {
          this.navList = data
          // this.defaultRoutePush(this.navList[0])
        } else {
          this.navList = []
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue